var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCertification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "60px",
    height: "60px",
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "6199B303-97E1-4496-AB3B-DAEA550B319B") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0.00025 59.9999 0.00025 59.9999 60 0 60"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Help",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "General-Help-Page_V3",
    transform: "translate(-98.000000, -901.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "certification",
    transform: "translate(98.000000, 901.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9999,0.00025 C13.4314,0.00025 -9.99999997e-05,13.43125 -9.99999997e-05,30.00025 C-9.99999997e-05,46.56875 13.4314,60.00025 29.9999,60.00025 C46.5689,60.00025 59.9999,46.56875 59.9999,30.00025 C59.9999,13.43125 46.5689,0.00025 29.9999,0.00025 M29.9999,1.50025 C45.7154,1.50025 58.4999,14.28475 58.4999,30.00025 C58.4999,45.71525 45.7154,58.50025 29.9999,58.50025 C14.2849,58.50025 1.4999,45.71525 1.4999,30.00025 C1.4999,14.28475 14.2849,1.50025 29.9999,1.50025",
    id: "Fill-1",
    fill: "#EDEBE9",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-4",
    stroke: "#05314D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "42.6923077 22.0515086 42.6923077 17.6043082 37.5573718 12.6923077 17.3076923 12.6923077 17.3076923 42.6923077 33.7107799 42.6923077"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-5",
    stroke: "#05314D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "38.0769231 12.6923077 38.0916763 17.3076923 42.6923077 17.3076923"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(32.307692, 23.076923)",
    stroke: "#05314D",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.33117949,1.396 L8.90092308,2.68882051 C9.16912821,3.29702564 9.80041026,3.66164103 10.4614359,3.58933333 L11.8660513,3.43651282 C13.184,3.2934359 14.0450256,4.78369231 13.2614359,5.85394872 L12.4270769,6.99394872 C12.0342564,7.53035897 12.0342564,8.25958974 12.4270769,8.796 L13.2614359,9.93548718 C14.0450256,11.0052308 13.184,12.4965128 11.8660513,12.3529231 L10.4614359,12.2001026 C9.80041026,12.1283077 9.16912821,12.4929231 8.90092308,13.1011282 L8.33117949,14.3939487 C7.79630769,15.6067692 6.07476923,15.6067692 5.53989744,14.3939487 L4.96964103,13.1011282 C4.70194872,12.4929231 4.07015385,12.1283077 3.40912821,12.2001026 L2.00502564,12.3529231 C0.687076923,12.4965128 -0.173948718,11.0052308 0.609128205,9.93548718 L1.444,8.796 C1.83682051,8.25958974 1.83682051,7.53035897 1.444,6.99394872 L0.609128205,5.85394872 C-0.173948718,4.78369231 0.687076923,3.2934359 2.00502564,3.43651282 L3.40912821,3.58933333 C4.07015385,3.66164103 4.70194872,3.29702564 4.96964103,2.68882051 L5.53989744,1.396 C6.07476923,0.182666667 7.79630769,0.182666667 8.33117949,1.396 Z",
    id: "Stroke-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0364103,7.70107692 C10.0364103,9.32723077 8.71846154,10.6446667 7.09282051,10.6446667 C5.46666667,10.6446667 4.14923077,9.32723077 4.14923077,7.70107692 C4.14923077,6.0754359 5.46666667,4.75748718 7.09282051,4.75748718 C8.71846154,4.75748718 10.0364103,6.0754359 10.0364103,7.70107692 Z",
    id: "Stroke-8"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-10",
    points: "2.00507692 12.3530256 2.00507692 22.9961026 6.93533333 17.3550769 12.0214872 22.9961026 12.0214872 12.3530256"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertification);
export default __webpack_public_path__ + "static/media/certification.ecb0225c76e829d6a0ef2dd1579070a6.svg";
export { ForwardRef as ReactComponent };